export var randomizeVector = function () {
    var min = -10;
    var max = 10;
    return [
        Math.floor(Math.random() * (max - min + 1)) + min,
        Math.floor(Math.random() * (max - min + 1)) + min,
    ];
};
